<template lang="pug">
    ib-application(layout="scroll", :translations="translations", row, class="ga-view")
        FinExplorer
</template>

<script>
import FinExplorer from './components/FinExplorer.vue'

    export default {
        components: {
            FinExplorer
        },

        data() {
            return {
                translations: _i18n.translations
            };
        }
    }
</script>
